export default "__VITE_ASSET__BC8n3Z$b__"